export * from './pipes/shared-pipes.module';
export * from './components';
export * from './modules';
export * from './guard/auth.guard';



// WEBPACK FOOTER //
// ./src/app/shared/index.ts